var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7679 4.5L7.23207 4.5C5.68849 4.5 4.72675 6.17443 5.50451 7.50774L7.27244 10.5385C8.0442 11.8615 9.9558 11.8615 10.7276 10.5385L12.4955 7.50774C13.2732 6.17443 12.3115 4.5 10.7679 4.5Z",
    fill: "#F45B69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowred);
export default __webpack_public_path__ + "static/media/down-arrow red.2f0f327b734473cf51df9b3c19767ebd.svg";
export { ForwardRef as ReactComponent };